export enum ReceiptNotificationAttachmentType {
  Pdf = 'PDF',
  Png = 'PNG',
  Jpg = 'JPG',
  None = 'NONE',
}
